<div *ngIf="showDropdownPoi">
    <mat-form-field>
        <mat-label>{{'FORM.gameRecordForm.poi' | translate}}</mat-label>
        <mat-select [formControl]="poi">
            <mat-option *ngFor="let poi of dropdownPoi" [value]="poi">{{poi.shortName}}</mat-option>
        </mat-select>
        <button mat-button *ngIf="poi.value" matSuffix mat-icon-button aria-label="Clear" (click)="resetPoi()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
<div style="position: relative;">
    <div id="menu">
        <mat-radio-group (change)="onMapStyleSelectChange($event)">
            <mat-radio-button [value]="mapStyleOutdors" [checked]="true">{{'map_style_outdoors' | translate}}</mat-radio-button>
            <mat-radio-button [value]="mapStyleSatellite">{{'map_style_satelite' | translate}}</mat-radio-button>
        </mat-radio-group>    
    </div>
    <div id="info_map" class="map"></div>
    
</div>
<div class="my-3">
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="disabled">{{'FORM.BTN_SAVE' | translate}}</button>
</div>